import { Typography } from '@mui/material';

export const UnauthorizedFormTabContent = () => (
  <Typography variant="h6" width="100%" my={4} textAlign="center">
    Additional permissions required
  </Typography>
);

export default UnauthorizedFormTabContent;
